<template>
    <div v-if="isBlank" class="content-block"></div>
    <div v-else
         class="content-block" 
         v-bind:class="{ 'underline': hasUnderLine }">
        <div class="block-top">
            <div class="label">
                <div class="label-name">{{ labelName }}</div>
                <div class="label-no">{{ labelNo }}</div>
            </div>
            <div v-if="illustration" class="illustration">
                <img v-bind:src="illustration" />
            </div>
        </div>        
        <div class="title">
            <div class="en-title">{{ enTitle }}</div>
            <div class="cn-title">{{ cnTitle }}</div>
        </div>
        <div class="content">
            <div v-if="contentImg" class="content-img">
                <div class="imgbox">
                    <div class="image" :style="{backgroundImage: `url(${contentImg})`}" />
                </div>
            </div>
            <div class="content-text">{{ contentText }}</div>
        </div>
    </div>
</template>
    
<script>
export default {
    name: 'ContentBlock',
    props: [
        'isBlank',
        'hasUnderLine',
        'labelName', 
        'labelNo',
        'illustration',
        'enTitle', 
        'cnTitle',
        'contentImg',
        'contentText'
    ]
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .content-block {
        display: block;
        position: relative;        
        width: 270px;
        margin: 50px 30px;
        color: $darkGray;

        & .block-top {
            position: relative;

            & .label {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 62px;
                border-bottom: 6px solid $darkGray;

                & .label-name {
                    font-family: "Roboto";
                    font-weight: 900;
                    font-size: 16px;
                }

                & .label-no {
                    font-family: "Impact", "Fugaz One";
                    font-size: 60px;
                }
            }

            & .illustration {
                position: absolute;
                bottom: 0;
                right: 10px;
            }
        }        

        & .title {
            & .en-title {
                margin: 20px 0 15px;
                font-family: "Roboto";
                font-size: 24px;
                font-weight: 800;                
            }

            & .cn-title {
                margin-bottom: 8px;
                font-size: 20px;
                font-weight: bold;
                letter-spacing: 0.5px;
            }
        }

        & .content {
            & .content-img {
                position: relative;
                width: 100%;
                background-color: gray;
                margin-bottom: 20px;
                overflow: hidden;

                & .imgbox {
                    position: relative;
                    width: 100%;
                    height: 0;
                    padding-top: 56%;

                    & .image {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center;
                    }
                }
            }

            & .content-text {
                font-size: 16px;
                font-weight: normal;
                letter-spacing: 0.5px;
                line-height: 1.5;
                color: #555;
            }
        }
    }

    .underline {
        border-bottom: 6px solid $darkGray;
        padding-bottom: 20px;
    }

    @media all and (max-width: 960px) {
        .content-block {
            width: 100% !important;
            margin: 50px 60px !important;
        
            & .block-top {

                & .illustration {
                    bottom: -60px !important;
                }
            } 
        }        
    }

    @media all and (max-width: 768px) {
        .content-block {
            margin: 50px 35px !important;
        
            & .block-top {

                & .illustration {
                    bottom: -25px !important;
                }
            } 
        }        
    }

    @media all and (max-width: 480px) {
        .content-block {
            margin: 50px 30px !important;
        
            & .block-top {

                & .illustration {
                    bottom: -20px !important;
                }
            } 
        }        
    }

    @media all and (max-width: 320px) {
        .content-block {
            margin: 40px 20px !important;
        }        
    }
</style>



// WEBPACK FOOTER //
// ContentBlock.vue?361ebef2